import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './InstagramFeed.css';

const {FiExternalLink, FiInstagram} = FiIcons;

function InstagramFeed() {
  return (
    <section className="instagram-section">
      <div className="instagram-heading">
        <div>
          <span className="eyebrow">
            <SafeIcon icon={FiInstagram} />
            Follow along
          </span>
          <h2>Instagram feed</h2>
          <p>Recent posts from Prof. Dr. S. Vikneswaran.</p>
        </div>
        <a
          className="button button-secondary"
          href="https://www.instagram.com/drvikneswaran/"
          target="_blank"
          rel="noreferrer"
        >
          Visit Instagram
          <SafeIcon icon={FiExternalLink} />
        </a>
      </div>
      <iframe
        className="instagram-embed"
        src="https://www.instagram.com/drvikneswaran/embed"
        title="Instagram posts from Prof. Dr. S. Vikneswaran"
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </section>
  );
}

export default InstagramFeed;